// import { Product } from "../components/Product";




// export const Main = () =>{


  


    
//     return (
//         <div class="main">
//         <h1>main</h1>
//         <Product value="/1" index={0}>1</Product>
//         <Product value="/2" index={1}>2</Product>
//         <Product value="/3" index={2}>3</Product>

//         </div>

//     )
// }

// import { Product } from "../components/Product";
// import "./Main.css"
// import img01 from "../img/img03.jpg";






// export const Main = () => {






//     return (

//         <div class="main">
//             <div className="main_b">
//                 <div className="mainbg">
//                     <img src={img01}></img>
//                     <img src={img01}></img>
//                 </div>
//                 <div className="main_a">
 
//                     <Product value="/1" index={0} className="mainpage1">1</Product>
//                     <Product value="/2" index={1} className="mainpage2">2</Product>
//                     <Product value="/3" index={2} className="mainpage3">3</Product>

      
//                     {/* <Product value="/1" index={0} className="mainpage1">1</Product>
//                     <Product value="/1" index={0} className="mainpage1">1</Product>
//                     <Product value="/1" index={0} className="mainpage1">1</Product> */}
                    
                    
  
//                     <Product value="/1" index={0} className="mainpage1">1</Product>
//                     <Product value="/2" index={1} className="mainpage2">2</Product>
//                     <Product value="/3" index={2} className="mainpage3">3</Product>

   
//                 </div>
//             </div>
//         </div>
//     )
// }

// import { Product } from "../components/Product";




// export const Main = () =>{


  


    
//     return (
//         <div class="main">
//         <h1>main</h1>
//         <Product value="/1" index={0}>1</Product>
//         <Product value="/2" index={1}>2</Product>
//         <Product value="/3" index={2}>3</Product>

//         </div>

//     )
// }

// import { Product } from "../components/Product";
// import "./Main.css"
// import img01 from "../img/img03.jpg";






// export const Main = () => {






//     return (

//         <div class="main">
//             <div className="main_b">
//                 <div className="mainbg">
//                     <img src={img01}></img>
//                     <img src={img01}></img>
//                 </div>
//                 <div className="main_a">
 
//                     <Product value="/1" index={0} className="mainpage1">1</Product>
//                     <Product value="/2" index={1} className="mainpage2">2</Product>
//                     <Product value="/3" index={2} className="mainpage3">3</Product>

      
//                     {/* <Product value="/1" index={0} className="mainpage1">1</Product>
//                     <Product value="/1" index={0} className="mainpage1">1</Product>
//                     <Product value="/1" index={0} className="mainpage1">1</Product> */}
                    
                    
  
//                     <Product value="/1" index={0} className="mainpage1">1</Product>
//                     <Product value="/2" index={1} className="mainpage2">2</Product>
//                     <Product value="/3" index={2} className="mainpage3">3</Product>

   
//                 </div>
//             </div>
//         </div>
//     )
// }

import { Product } from "../components/Product";
import "./Main.css"
import img01 from "../img/img02.jpg";



export const Main = () => {



    return (

        <div class="main">
            <div className="mainbg">
            </div>
            <div className="introduce">
                <h1>ArtKey란?</h1>

                <p>ArtKey는 예약 대체 서비스를 제공하는 플랫폼입니다.</p>
                <p>우리의 목표는 예약 프로세스를 간소화하고 예약 관리를 효율적으로 돕는 것입니다. ArtKey를 통해 예약을 대체하는 새로운 방법을 경험해보세요!</p>
            </div>
            <div className="mainpage">
                <Product value="/1" index={0} className="mainpage_pd">1</Product>
                <Product value="/2" index={1} className="mainpage_pd">2</Product>
                <Product value="/3" index={2} className="mainpage_pd">3</Product>
            </div>
            <div className="mainpage">
                <Product value="/4" index={3} className="mainpage_pd">4</Product>
                <Product value="/5" index={4} className="mainpage_pd">5</Product>
                <Product value="/6" index={5} className="mainpage_pd">6</Product>
            </div>
        </div>
    )
}